module.exports = __webpack_public_path__ + "static/media/instagram.bb026c4d.svg";